import { Card, Col, Container, Form, Row, Table } from 'react-bootstrap'
import Navbar from '../../components/navbar/navbar'
import { useState } from 'react'
import { CustomButton } from '../../components/CustomButton'
import { Search } from 'react-bootstrap-icons'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage'
import apinode from '../../services/apinode'
import { CustomInputDate } from '../../components/CustomInputDate'
import { ContentLoading } from '../../components/ContentLoading'
import { formatDate } from '../../utils/formatDate'
import { unifyParams } from '../../utils/unifyParams'
import { subMonths } from 'date-fns'
import { formatPrice } from '../../utils/formatPrice'

export function PedidosPorCliente() {
  const [search, setSearch] = useState({
    type: 'nome',
    value: '',
  })
  const [date, setDate] = useState({
    start: subMonths(new Date(), 1),
    end: new Date(),
  })
  const [isSearchLoading, setIsSearchLoading] = useState(false)
  const [data, setData] = useState({})

  const isDisabled = !search.value || !search.type || !date.start || !date.end

  async function buscarPedidos() {
    setData({})

    try {
      setIsSearchLoading(true)

      const url = unifyParams(`/pedidos-por-cliente/${localStorage.idconta}`, [
        {
          key: 'type',
          value: search.type,
        },
        {
          key: 'value',
          value: search.value,
        },
        {
          key: 'startDate',
          value: date.start,
        },
        {
          key: 'endDate',
          value: date.end,
        },
      ])

      const response = await apinode.get(url)

      setData(response.data)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao buscar pedidos')
    } finally {
      setIsSearchLoading(false)
    }
  }

  return (
    <>
      <Navbar />

      <Container className="mt-page">
        <h1>Pedidos por Cliente</h1>

        <Row>
          <Col xs={2}>
            <Form.Label>Tipo de Pesquisa</Form.Label>

            <Form.Select
              value={search.type}
              onChange={(e) =>
                setSearch((prevState) => ({
                  ...prevState,
                  type: e.target.value,
                }))
              }
            >
              <option value="nome">Nome</option>
              <option value="pedido">Pedido</option>
              <option value="cpf">CPF | CNPJ</option>
            </Form.Select>
          </Col>

          <Col>
            <Form.Label>Pesquisa</Form.Label>

            <Form.Control
              value={search.value}
              placeholder="Digite aqui..."
              onChange={(e) =>
                setSearch((prevState) => ({
                  ...prevState,
                  value: e.target.value,
                }))
              }
              onKeyDown={(e) => {
                console.log(e.key === 'Enter' && !isDisabled)

                if (e.key === 'Enter' && !isDisabled) {
                  buscarPedidos()
                }
              }}
            />
          </Col>

          <Col>
            <div
              style={{
                display: 'flex',
                gap: 5,
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Form.Label>De: </Form.Label>

                <CustomInputDate
                  selected={date.start}
                  onChange={(date) =>
                    setDate((prevState) => ({ ...prevState, start: date }))
                  }
                  selectsStart
                  startDate={date.start}
                  endDate={date.end}
                />
              </div>

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Form.Label>Até: </Form.Label>

                <CustomInputDate
                  selected={date.end}
                  onChange={(date) =>
                    setDate((prevState) => ({ ...prevState, end: date }))
                  }
                  selectsEnd
                  startDate={date.start}
                  endDate={date.end}
                  minDate={date.start}
                />
              </div>
            </div>
          </Col>

          <Col
            style={{
              display: 'flex',
              alignItems: 'flex-end',
            }}
          >
            <CustomButton
              title="Pesquisar"
              isDisabled={isDisabled}
              isLoading={isSearchLoading}
              isLoadingText="Pesquisando..."
              onClick={buscarPedidos}
            >
              <Search />
            </CustomButton>
          </Col>
        </Row>

        <ContentLoading
          isLoading={isSearchLoading}
          loadingText="Carregando..."
        >
          {data?.cliente && (
            <Card className="mt-3">
              <Card.Body
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <strong>{data?.cliente?.pes_razao}</strong>

                  <strong>{data?.cliente?.pes_cnpj_cpf}</strong>
                </div>

                <strong>{data?.pedidos.length} pedidos</strong>
              </Card.Body>
            </Card>
          )}

          <hr />

          {data?.pedidos?.map((pedido) => (
            <Card>
              <Card.Body>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <strong>Pedido #{pedido.pedido}</strong>

                    <strong>{formatDate(pedido.data)}</strong>
                  </div>

                  <strong>{pedido?.produtos.length} produtos</strong>
                </div>

                <hr />

                <Table>
                  <thead>
                    <tr>
                      <th>SKU</th>
                      <th>Nome</th>
                      <th>Valor Uni.</th>
                      <th>Qtde</th>
                      <th>Valor Total</th>
                    </tr>
                  </thead>

                  <tbody>
                    {pedido?.produtos.map((produto) => (
                      <tr>
                        <td>{produto.codigo}</td>
                        <td>{produto.descricao}</td>
                        <td>{formatPrice(produto.valorunitario)}</td>
                        <td>{produto.quantidade_nova}</td>
                        <td>{formatPrice(produto.valor_total_item)}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          ))}
        </ContentLoading>
      </Container>
    </>
  )
}
